import * as scrollActions from 'client/common/store/actions/scroll';

import {animateScroll, scroller} from 'react-scroll';

import {takeEvery} from 'redux-saga/effects';

export function scrollToTop() {
    animateScroll.scrollToTop({
        duration: 500,
        smooth: true
    });
}

export function scrollToClassName(action: ReturnType<typeof scrollActions.scrollToClassName>) {
    const {offset = 0, className} = action.payload;

    scroller.scrollTo(className, {
        duration: 500,
        smooth: true,
        offset
    });
}

export function scrollToError() {
    scroller.scrollTo('error-label', {
        duration: 500,
        smooth: true,
        offset: -80
    });
}

export default function* router() {
    yield takeEvery(scrollActions.scrollToTop.type, scrollToTop);
    yield takeEvery(scrollActions.scrollToClassName.type, scrollToClassName);
    yield takeEvery(scrollActions.scrollToError.type, scrollToError);
}
